export const TrustBadge = {
  BACKGROUND_CHECKED: 'Background checked',
  ID_VERIFIED: 'ID verified',
  FIRST_AID: 'First aid',
  HIGHLY_RATED: 'Highly rated',
}

export const BookingStatus = {
  DRAFT: 'draft',
  PENDING_PAYMENT: 'pending_payment',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
}

export const BookingStatusLabel = {
  draft: 'Draft',
  pending_payment: 'Pending payment',
  confirmed: 'Confirmed',
  cancelled: 'Cancelled',
  completed: 'Completed',
}

export const PaymentStatus = {
  PENDING: 'pending',
  AUTHORIZED: 'authorized',
  PAID: 'paid',
  FAILED: 'failed',
  REFUNDED: 'refunded',
}

export const emptyBookingDraft = {
  parentInfo: null,
  children: [],
  schedule: null,
  selectedNonna: null,
}

/**
 * @returns {typeof emptyBookingDraft}
 */
export function createEmptyBookingDraft() {
  return { ...emptyBookingDraft, children: [] }
}